import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { getNumSliderValues } from '../scenes/poker/pixiComponents/slider/sliderUtils';
import { DomBetSlider } from './domBetSlider';
import { DomBetStepButtons } from './domBetStepButtons';
export function shouldShowBetSlider(myTurnProperties, isSimpleBettingEnabled) {
    if (isSimpleBettingEnabled) {
        return false;
    }
    const { hasRangeOfPossibleBets, canBet, canRaise } = myTurnProperties;
    if (!hasRangeOfPossibleBets) {
        return false;
    }
    return canBet || canRaise;
}
/**
 * Combination of the draggable bet slider and the bet "step" buttons to increase and decrease the bet amount incrementally.
 */
export const DomBetSliderCombo = ({ myTurnProperties, bounds }) => {
    const { betSliderAmount, betIncrement, betSliderMinAmount, betSliderMaxAmount } = myTurnProperties;
    const containerCss = useMemo(() => css `
      position: relative;
      left: ${bounds.x}px;
      top: ${bounds.y}px;
      width: ${bounds.w}px;
      height: ${bounds.h}px;
    `, [bounds.h, bounds.w, bounds.x, bounds.y]);
    const numSliderValues = useMemo(() => getNumSliderValues(betSliderMinAmount, betSliderMaxAmount, betIncrement), [betIncrement, betSliderMaxAmount, betSliderMinAmount]);
    if (numSliderValues <= 1) {
        return null;
    }
    // relative to the container
    const betStepButtonsBounds = {
        x: 0,
        y: 0,
        w: bounds.w,
        h: bounds.h / 2
    };
    // relative to the container
    const sliderBounds = {
        x: 0,
        y: bounds.h / 2,
        w: bounds.w,
        h: bounds.h / 2
    };
    const buttonWidth = Math.min(Math.max(bounds.w / 5, 40), bounds.w / 2);
    return (_jsxs("div", { css: containerCss, children: [_jsx(DomBetStepButtons, { myTurnProperties: myTurnProperties, bounds: betStepButtonsBounds }), _jsx(DomBetSlider, { bounds: sliderBounds, buttonWidth: buttonWidth, betSliderAmount: betSliderAmount, numValues: numSliderValues, minValue: betSliderMinAmount, maxValue: betSliderMaxAmount, increment: betIncrement })] }));
};
